var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 46,
    viewBox: "0 0 48 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_197_366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4675 0H6.53248C2.92469 0 0 2.79008 0 6.23182V39.5584C0 43.0001 2.92469 45.7902 6.53248 45.7902H41.4675C45.0753 45.7902 48 43.0001 48 39.5584V6.23182C48 2.79008 45.0753 0 41.4675 0Z",
    fill: "#111834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4379 36V24.1409H29.2708L29.8448 19.5186H25.4379V16.5677C25.4379 15.229 25.7954 14.3176 27.6434 14.3176L30 14.3164V10.1821C29.5922 10.1261 28.1938 10 26.5658 10C23.1689 10 20.8425 12.1537 20.8425 16.1096V19.5181H17V24.1402H20.8425V35.9993L25.4379 36Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_197_366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.b6402b5a1e71d4b3b5f86109041b5b61.svg";
export { ForwardRef as ReactComponent };